// @ts-ignore
import { createRequestActionNames } from 'helpers'

export const NOTIFICATIONS = createRequestActionNames('NOTIFICATIONS', ['GET'])
export const NOTIFICATIONS_LOAD_MORE = createRequestActionNames('NOTIFICATIONS_LOAD_MORE', ['GET'])
export const NOTIFICATIONS_UNREAD_COUNT = createRequestActionNames('NOTIFICATIONS_UNREAD_COUNT', ['GET'])
export const NOTIFICATIONS_MARKED_READ = createRequestActionNames('NOTIFICATIONS_MARKED_READ', ['GET'])
export const NOTIFICATIONS_SCROLL = 'NOTIFICATIONS_SCROLL'
export const NOTIFICATIONS_ENABLE_GET_PENDING = 'NOTIFICATIONS_ENABLE_GET_PENDING'
export const NOTIFICATIONS_ENABLE_LOAD_MORE_PENDING = 'NOTIFICATIONS_ENABLE_LOAD_MORE_PENDING'
export const REACTION_CREATED = 'REACTION_CREATED'
export const REACTION_UPDATED = 'REACTION_UPDATED'
export const MENTION_CREATED = 'MENTION_CREATED'
export const PEER_INVITE_ACCEPTED = 'PEER_INVITE_ACCEPTED'
